export enum EditableIssueFields {
  TITLE = 'title',
  DESCRIPTION = 'description',
  SEVERITY = 'severity',
  DUE_DATE = 'dueDate',
  ISSUE_OWNER = 'issueOwner',
  ISSUE_MANAGER = 'issueManager',
  ISSUE_APPROVER = 'issueApprover',
  IMPACTED_ENTITY = 'impactedEntity',
  EXECUTION_TYPE = 'executionType',
  ATTACHMENTS = 'attachments',
  IMPACT = 'impact',
}
